/**
 * The page title row under the breadcrumbs, with a divider beneath it, as on
 * the Community, Dashboard and Analysis pages. Anything passed as children
 * (e.g. Community's buttons and filter) sits to the right of the title.
 * @param {string} title
 */
export default function PageHeading({ title, children }) {
    return (
        <div className="dashboard-header">
            <div className="row align-items-center">
                <div className="col-md-3">
                    <h2 className="mb-0">{title}</h2>
                </div>
                {children && <div className="col-md-9">{children}</div>}
            </div>
        </div>
    )
}
